document.addEventListener("DOMContentLoaded", () => {
    let isDesktop = window.innerWidth >= '1200';

    if (isDesktop) {
        (function gsapScrollPanel() {
            const scrollBarWidth = window.innerWidth - document.body.clientWidth;

            let controllerScrollPanel,
                scrollSceneDefaultForward,
                scrollSceneDefaultReverse,
                resizeTimer;

            const scrollContainers = document.querySelectorAll(".split-screens-block-container:not(.split-screens-block-container--mobile) .split-screens-block");

            // If the .fullpage container exists, set up the fullpage section animations
            if (scrollContainers) {
                initController();
                handleResize();
            }

            function shiftElementsRelativeToScrollbar(shiftWidth) {
                document.body.style.paddingRight = `${shiftWidth}px`;

                const popups = document.querySelectorAll(".popup__content");

                if (popups.length) {
                    popups.forEach(popup => {
                        popup.style.marginRight = `${shiftWidth}px`;
                    })
                }

                const goUpButtons = document.querySelectorAll(".go-up-button");

                if (goUpButtons.length) {
                    goUpButtons.forEach(button => {
                        button.style.marginRight = `${shiftWidth}px`;
                    })
                }
            }

            function hideShowScroll() {
                document.body.classList.add('scroll-disabled');
                shiftElementsRelativeToScrollbar(scrollBarWidth);

                setTimeout(function() {
                    document.body.classList.remove('scroll-disabled');
                    shiftElementsRelativeToScrollbar(0);
                },1000)
            }

            function setBackground(element) {
                const pic = element.querySelector(".split-screen-block-picture img");
                const icon = element.querySelector(".split-screen-block-picture .branding-icon");
                return `url(${icon ? icon.getAttribute("src") : null}), url('${pic.getAttribute("src")}')`;
            }

            function animateBackground(element) {
                element.classList.add('animated');
                setTimeout(() => {
                    element.classList.remove('animated');
                }, 1000);
            }


            function scrollOptions(elem, str) {
                return str === 'enter' ?
                {
                    offset: 40,
                    triggerElement: elem,
                    triggerHook: 0
                } :
                {
                    offset: 0,
                    triggerElement: elem,
                    triggerHook: 0.3
                }
            }

            function calcScrollPos(elem, str, bgImage = null) {
                if (str === 'next') {
                    return elem.nextElementSibling ?
                    elem.nextElementSibling.getBoundingClientRect().top - 80 :
                    elem.getBoundingClientRect().top + window.innerHeight + 40 - 80
                } else {
                    return elem.previousElementSibling !== bgImage ?
                    elem.previousElementSibling.getBoundingClientRect().top - 80
                    : elem.getBoundingClientRect().top - window.innerHeight - 129 - 100 ;
                }
            }

            // Initialize the scrollMagic controller
            function initController() {
                // Init new controller
                controllerScrollPanel = new ScrollMagic.Controller();
                let reInitScroll = false;

                // Change behaviour of controller to animate scroll instead of jump
                    controllerScrollPanel.scrollTo(function (newpos) {
                        if (!reInitScroll) {
                            gsap.to(window, {duration: 0.5, scrollTo: newpos});
                        }  else {
                            destroyScrollPanels();
                            reInitScroll = false;
                        }
                    });


                // Init the forward and reverse scenes
                scrollPanelScenes();

                document.addEventListener("destroyScrollPanels", function(_) {
                    reInitScroll = true;
                });

                window.addEventListener('scroll', () => {
                    if (window.scrollY === 0) {
                        destroyScrollPanels();
                        reInitScrollPanels();
                    }
                })
            }


            // If window is resized, destroy controller and reset once resize has stopped
            function handleResize() {
                function doneResizing(){
                    reInitScrollPanels();
                }
                window.addEventListener('resize', (function() {
                    destroyScrollPanels();
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(doneResizing, 500);
                }));
            }


            // Destroy scroll panels
            function destroyScrollPanels() {
                controllerScrollPanel.destroy();
                scrollSceneDefaultForward.destroy();
                scrollSceneDefaultReverse.destroy();
            }


            // Re-init scroll panels
            function reInitScrollPanels() {
                controllerScrollPanel = null;
                scrollSceneDefaultForward = null;
                scrollSceneDefaultReverse = null;
                initController();
            }

            // The forward and reverse scenes
            function scrollPanelScenes() {
                // Create scenes for panels, when scrolling forward
                if (scrollContainers) {
                    scrollContainers.forEach((scrollContainer) => {
                        const firstScreen = scrollContainer.querySelector(".split-screen-block");
                        const lastScreen = scrollContainer.querySelector(".split-screen-block:last-child");
                        const bgImage = scrollContainer.querySelector('.split-screen-block-bg-image');

                        if (!scrollContainer.parentNode.classList.contains('split-screens-block-container--single')) {
                            const scrollSections = scrollContainer.querySelectorAll('.split-screen-block');
                            scrollSections.forEach(function(elem, index, array) {
                                bgImage.style.backgroundImage = setBackground(array[0]);

                                const forwardScrollPos = calcScrollPos(elem, 'next')

                                scrollSceneDefaultForward = new ScrollMagic.Scene(scrollOptions(elem, 'enter'))
                                .on('start', function(event) {
                                    if (event.scrollDirection == 'FORWARD') {
                                        controllerScrollPanel.scrollTo(forwardScrollPos); // If direction is forward, trigger scrollTo
                                    } else if (event.scrollDirection == 'REVERSE') {
                                        // Do nothing
                                    }
                                })
                                // Prevent problems with momentum scrolling by pausing for a period of time
                                .on('enter', function(event) {
                                    hideShowScroll();
                                })
                                .addTo(controllerScrollPanel);

                                new ScrollMagic.Scene(scrollOptions(elem, 'enter'))
                                // Prevent problems with momentum scrolling by pausing for a period of time
                                .on('enter', function(event) {
                                    if (array[index + 1]) {
                                        animateBackground(bgImage);
                                        bgImage.style.backgroundImage = setBackground(array[index + 1]);
                                    }
                                })
                                .addTo(controllerScrollPanel);
                            })

                            const reversedScrollSections = scrollContainer.querySelectorAll('.split-screen-block:nth-child(n+2)');

                            // Create scenes for panels, when scrolling reverse
                            reversedScrollSections.forEach(function(elem, index, array) {
                                const reverseScrollPos = calcScrollPos(elem, 'prev', bgImage)

                            scrollSceneDefaultReverse = new ScrollMagic.Scene(scrollOptions(elem))
                            .on('start', function(event) {
                                if (event.scrollDirection == 'FORWARD') {
                                // Do nothing
                                } else if (event.scrollDirection == 'REVERSE') {
                                    controllerScrollPanel.scrollTo(reverseScrollPos); // If direction is reverse, trigger scrollTo
                                }
                            })
                            // Prevent problems with momentum scrolling by pausing for a period of time
                            .on('leave', function(event) {
                                hideShowScroll();
                            })
                            .addTo(controllerScrollPanel);

                            new ScrollMagic.Scene(scrollOptions(elem))
                            .on('leave', function() {
                                if (array[index - 1]) {
                                    animateBackground(bgImage);
                                    bgImage.style.backgroundImage = setBackground(array[index - 1]);
                                }
                            })
                            .addTo(controllerScrollPanel);
                            })

                        } else {
                            const singleBlockImageContainer = scrollContainer.querySelector('.split-screen-block');
                            if (singleBlockImageContainer) {
                               bgImage.style.backgroundImage = setBackground(singleBlockImageContainer)
                            }
                        }

                        function attachBackground() {
                            if (window.scrollY >= firstScreen.getBoundingClientRect().top+pageYOffset - 80 && window.scrollY < lastScreen.getBoundingClientRect().top+pageYOffset + 100) {
                                bgImage.classList.add("attached");
                            } else {
                                if (window.scrollY >= lastScreen.getBoundingClientRect().top+pageYOffset) {
                                    bgImage.classList.add("bottom-bg");
                                } else {
                                    bgImage.classList.remove("bottom-bg")
                                }

                                bgImage.classList.remove("attached")
                            }
                        }

                        if (!scrollContainer.parentNode.classList.contains('split-screens-block-container--single')) {
                            window.addEventListener("scroll", attachBackground)
                        }
                    })
                }
            }
        }());
    };

    (function createMobileSlider() {
        function getPaginationConfig(swiper, isCustom = false) {
            const paginationWrapper = swiper.parentNode.querySelector(".swiper-pagination")
            if (!paginationWrapper) {
                return {
                    enabled: false,
                }
            }

            const type = !isCustom
                ? { type: "bullets" }
                : {
                      type: "custom",
                  }

            return {
                el: swiper.parentNode.querySelector(".swiper-pagination"),
                clickable: true,
                enabled: true,
                ...type,
            }
        }

        const pictureSlider = document.querySelector('.split-screen-pictures-container');

        if (pictureSlider) {
            const pictureSwiper = new Swiper('.split-screen-pictures-container', {
                speed: 800,
                spaceBetween: 0,
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: getPaginationConfig(pictureSlider)
            });


            const infosSlider = new Swiper('.split-screen-infos-container', {
                speed: 800,
                spaceBetween: 0,
                slidesPerView: 1.2,
                effect: 'slide',
            });

            if (infosSlider && pictureSwiper) {
                infosSlider.controller.control = pictureSwiper;
                pictureSwiper.controller.control = infosSlider;
            }
        }
    }())
})
